<template>
	<div class="qms-file-upload position-relative w-100 h-100 rmk">
		<div class="ml-1" :style="`width: ${width} !important; height: ${height} !important; `">
			<div v-for="(history, idx) in rmkHistory" :key="history.affrPrcsDt + idx">
				<div class="mb-1 d-flex w-100" style="flex-direction: row">
					<div class="mr-2 w-100">
						<strong>{{ '[' + history.pgsStNm + ']' }} </strong>
						<span class="mx-1">{{ history.affrPrcsDt }}</span>
						<strong class="writer">{{ history.affrDspoNm }}</strong>
						<span class="passage" v-if="!!history.rmk">: {{ getMessage_(history.rmk) }}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
export default {
	props: {
		width: { type: String, default: '100%' },
		height: { type: String, default: '100%' },
		rmkHistory: {
			type: Array,
			default: () => {
				return [{ pgsStNm: '', affrPrcsId: '', affrPrcsDt: '', rmk: '' }];
			}
		}
	},
	methods: { ...rootMethods },
	computed: { ...rootComputed }
};
</script>

<style lang="scss" scoped>
.rmk {
	overflow-y: scroll;
	overflow-x: hidden;
	text-align: left;
	.writer {
		text-decoration: underline;
	}
	.passage {
		word-wrap: normal;
	}
}
</style>
